export enum RecaptchaVersion {
  V3 = 'v3',
  V2 = 'v2',
}
